import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithOnlineCourse from '../../app/baseQueryWithOnlineCourse'
import { ListResponse, PaginationState, SubjectAnalyticState } from '../types';

interface courseAnalyticsParam extends PaginationState {
    courseId: number
}

export const subjectApiSlice = createApi({
    reducerPath: 'subjectApi',
    baseQuery: baseQueryWithOnlineCourse,
    tagTypes: ['Subject', 'Analytic'],
    endpoints: (build) => ({
        fetchAllSubjects: build.query<any, void>({
            query: () => ({
                url: 'subject',
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ id }) => ({
                              type: 'Subject' as const,
                              id,
                          })),
                          { type: 'Subject', id: 'LIST' },
                      ]
                    : [{ type: 'Subject', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        createSubject: build.mutation<FormData, FormData>({
            query: (subject) => ({
                url: '/subject',
                method: 'POST',
                body: subject,
            }),
            invalidatesTags: [{ type: 'Subject', id: 'LIST' }],
        }),

        updateSubject: build.mutation<FormData, FormData>({
            query: (subject) => ({
                url: `/subject/${subject.get('id')}`,
                method: 'PUT',
                body: subject,
            }),
            invalidatesTags: [{ type: 'Subject', id: 'LIST' }],
        }),

        deleteSubject: build.mutation<{ success: boolean; id: number }, number>(
            {
                query: (id) => ({
                    url: `/subject/${id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: (result, error, id) => [
                    { type: 'Subject', id },
                ],
            },
        ),

        fetchAnalytics: build.query<
            ListResponse<SubjectAnalyticState>,
            courseAnalyticsParam
        >({
            query: ({ page, size, courseId }) => ({
                url: `analytics/course/${courseId}`,
                params: {
                    page,
                    size,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                            ...result.data.map(({ id }) => ({
                                type: 'Analytic' as const,
                                id,
                            })),
                            { type: 'Analytic', id: 'LIST' },
                        ]
                    : [{ type: 'Analytic', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<SubjectAnalyticState>
            }) => ({
                data: response?.data?.data,
                pageNumber: response?.data?.pageNumber,
                totalCount: response?.data?.totalCount,
                totalPages: response?.data?.totalPages,
            }),
        }),
    }),
})
